import type { Cents } from './types';

/**
 * Shared CSV field formatting for the two CSV exporters
 * (`export-csv.ts` and `export-bill-csv.ts`).
 */

/**
 * RFC 4180 quoting — wrap in double quotes when the field contains a
 * delimiter, quote, or line break; double any embedded quotes.
 */
export function quote(s: string): string {
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * Formula-injection guard for TEXT fields. A cell starting with `=`, `+`,
 * `-`, `@`, tab or CR executes as a formula when the CSV is opened in
 * Excel / LibreOffice, so a vendor name OCR'd (or typed) as `=cmd|...`
 * would run on the user's machine. Prefixing a single quote makes the
 * spreadsheet treat the cell as literal text — the standard mitigation.
 *
 * Apply this to text fields ONLY. Numeric amount columns come from
 * `centsToDecimal` and can legitimately start with `-`; prefixing them
 * would break their numeric typing on import.
 */
export function escapeText(s: string): string {
  return /^[=+\-@\t\r]/.test(s) ? `'${s}` : s;
}

/** Integer cents → decimal string for CSV amount columns (1234 → "12.34"). */
export function centsToDecimal(cents: Cents): string {
  return (cents / 100).toFixed(2);
}
